exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".perm-hero-image{margin-top:-30px;margin-left:-25px;margin-right:-25px;background-color:#fff}.perm-hero-image .main-product{background-size:cover;background-position:center;height:210px;width:100%;overflow:hidden}.product-tab{position:sticky;top:74px;z-index:9}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/ProductLanding/permproduct.scss
// module id = 7612
// module chunks = 101